import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';

import { NextImage } from '../NextImage';

import { ReactComponent as CloseSvg } from '@/assets/icons/close.svg';

export const DropzoneStyle = styled(Flex)<{ $error: boolean }>`
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 164px;
  ${({ $error, theme }) => css`
    padding: ${theme.spacing(1)};
    border: 1px solid ${$error ? theme.colors.error : theme.colors.lightGray};
    background: ${theme.colors.lightGrey};
  `}
`;

export const PreviewContainerStyle = styled(Flex)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  ${({ theme }) => css`
    padding: ${theme.spacing(1.5)};
  `}
`;

export const PreviewImageStyle = styled(NextImage)`
  width: 108px;
  height: 108px;
  object-fit: cover;
`;

export const DropzoneInfoWrapper = styled.button`
  max-width: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font: inherit;
  color: inherit;
  text-align: center;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primaryBlue};
    outline-offset: 2px;
  }
`;

export const Text = styled(Typography)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(1.5)};
    a {
      color: ${theme.colors.primaryDark};
      font-size: ${theme.fontSizes.p2};
      font-weight: ${theme.fontWeights.semibold};
      line-height: ${theme.spacing(2.75)};
    }
  `}
`;

export const Prompt = styled(Typography)`
  ${({ theme }) => css`
    color: ${theme.colors.primaryBlue};
    font-size: ${theme.fontSizes.p2};
    font-weight: ${theme.fontWeights.regular};
    font-family: ${theme.fontFamilies.openSans};
    line-height: ${theme.spacing(2.75)};
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const ImagePreview = styled(Flex)`
  position: relative;
  ${({ theme }) => css`
    margin-right: ${theme.spacing(2)};
  `}
`;
export const CloseButton = styled.button`
  position: absolute;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  ${({ theme }) => css`
    top: ${theme.spacing(0.5)};
    right: ${theme.spacing(0.5)};
    height: ${theme.spacing(2)};
    width: ${theme.spacing(2)};
    border-radius: 50%;
    background: ${theme.colors.mediumGrey};
    border: 1px solid ${theme.colors.mediumGrey};
  `}
`;

export const CloseIcon = styled(CloseSvg)`
  width: 100%;
  height: 100%;
`;
export const AddImageButton = styled.button`
  width: 108px;
  height: 108px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primaryBlue};
    outline-offset: 2px;
  }

  ${({ theme }) => css`
    padding: ${theme.spacing(1)};
    border: 1px solid ${theme.colors.mediumGrey};
    background: ${theme.colors.white};
  `}
`;
